import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

//services
import { OrderService } from '../shared/services';

//enums
import { PaymentStatusEnum } from '../shared/enums/payment-status.enum';

//helpers
import { OrderHelper, PrinterHelper } from '../shared/helpers';

//interfaces
import { TransactionInterface } from '../shared/interfaces';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.scss'
})
export class CheckoutComponent implements OnInit, OnDestroy {
  public checkoutStatus: PaymentStatusEnum = PaymentStatusEnum.pending;
  public paymentStatusEnum = PaymentStatusEnum;
  private transactionRes: TransactionInterface;
  public printing: boolean = false;

  private $interval: any;
  private $timeout: any;

  private guid: string = '';

  constructor(
    private router: Router,
    private orderSerive: OrderService,
    private printerHelper: PrinterHelper
  ) { }

  async ngOnInit() {
    try {
      const res = await lastValueFrom(this.orderSerive.checkout())
      this.guid = res.guid; // save guid in case you need to retry afterwards
      this.awaitStatus()
    } catch (error) {
      console.log(error)
    }
  }
  private async awaitStatus() {
    try {
      this.$interval = setInterval(async () => {

        const val = await lastValueFrom(this.orderSerive.getCheckoutStatus(this.guid))
        this.checkoutStatus = val.status;
        if (this.checkoutStatus !== PaymentStatusEnum.pending) {
          clearInterval(this.$interval)
          if (this.checkoutStatus == PaymentStatusEnum.captured) {
            this.transactionRes = val;
          }
          if (this.checkoutStatus !== PaymentStatusEnum.captured && this.checkoutStatus !== PaymentStatusEnum.failed) {
            this.checkoutStatus = PaymentStatusEnum.unknown;
          }
        }
        OrderHelper.checkoutStatus.next(this.checkoutStatus);
      }, 1000);
    } catch (error) {
      throw new Error((error as HttpErrorResponse).error);
      console.log(error)
    }
  }

  async printReceipt() {
    if (this.printing) return
    this.printing = true;
    try {
      await this.printerHelper.printReceipt(this.transactionRes);
      this.$timeout = setTimeout(() => {
        this.router.navigate(['/home'])
      }, 2000);
    } catch (error) {
      console.log(error)
    }

  }


  public async retry() {
    try {
      await lastValueFrom(this.orderSerive.retryOrder(this.guid))
      this.awaitStatus();
    } catch (error) {
      console.log(error)
    }
  }

  ngOnDestroy(): void {
    if (this.$interval) clearInterval(this.$interval);
    if (this.$timeout) clearTimeout(this.$timeout);
  }
}
